import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ea62b248&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ea62b248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea62b248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea62b248')) {
      api.createRecord('ea62b248', component.options)
    } else {
      api.reload('ea62b248', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ea62b248&scoped=true&", function () {
      api.rerender('ea62b248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z3p8DU16s86p/JS/comp/PopupBox.vue"
export default component.exports